module.exports = __webpack_public_path__ + "static/media/penalty.54a744aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/penalty.svg
// module id = 359
// module chunks = 0